var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-box__time" },
    [
      _c("h3", {
        staticClass: "order-box__time-title",
        domProps: { innerHTML: _vm._s(_vm.$t("orderboxtime.title")) }
      }),
      _vm._v(" "),
      _vm._l(_vm.filteredYieldingMessages, function(message, i) {
        return _c("GeneralMessage", {
          key: "yielding" + i,
          attrs: { message: message, type: "promo", stick: "" }
        })
      }),
      _vm._v(" "),
      _vm.orderNowAvailable
        ? _c("FormInputCheckbox", {
            staticClass: "order-box__time-checkbox",
            attrs: {
              checked: _vm.orderNow,
              label: _vm.$t("orderboxtime.orderNowLabel"),
              immediate: ""
            },
            on: {
              input: function($event) {
                return _vm.$emit("ordernowchanged", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderNowAvailable && !_vm.orderNow
        ? _c("h4", {
            staticClass: "order-box__time-subtitle",
            domProps: {
              innerHTML: _vm._s(_vm.$t("orderboxtime.preorderLabel"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.orderNowAvailable || !_vm.orderNow
        ? _c(
            "div",
            { staticClass: "order-box__time-group" },
            [
              _c("FormInputDate", {
                staticClass: "order-box__time-date",
                attrs: {
                  placeholder: _vm.$t("forms.labels.date"),
                  label: _vm.$t("forms.labels.date"),
                  value: _vm.date,
                  initialValue: _vm.date,
                  "min-date": _vm.dateMin,
                  "max-date": _vm.dateMax,
                  isDateDisabled: _vm.isDateDisabled,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("datechanged", $event)
                  }
                }
              }),
              _vm._v(" "),
              _c("TimePicker", {
                staticClass: "order-box__time-time",
                attrs: {
                  value: _vm.time,
                  times: _vm.times,
                  label: _vm.$t("forms.labels.time"),
                  narrow: ""
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("timechanged", $event)
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.times.length && (!_vm.orderNow || !_vm.orderNowAvailable)
        ? _c("GeneralMessage", {
            attrs: {
              message: _vm.$t("orderboxtime.noTimes"),
              type: "error",
              stick: ""
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.uberDirect
        ? _c("GeneralMessage", {
            attrs: {
              message: _vm.$t("uberDirect.deliveryOrderbox"),
              type: "info",
              stick: ""
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Button", {
        staticClass: "order-box__time-button",
        attrs: {
          level: "primary",
          type: "button",
          text: _vm.buttonText,
          disabled:
            !_vm.times.length && (!_vm.orderNow || !_vm.orderNowAvailable)
        },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("click")
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }